import template from '../templates/global-account-menu.tpl.html';
import { DEFAULT_ACCOUNT_LINKS } from './defaults';

// Bundle SVG Icons
import caretIcon from '../assets/images/icons/caret-down.svg';

let sharedInstance = null;

export default class GlobalAccountMenu {

  constructor(container, options) {
    if (!sharedInstance) {
      sharedInstance = this;
    }

    this.caretIcon = caretIcon;

    this.container = container;
    this.options = options;

    this.render();
    this.observe();

    return sharedInstance;
  }

  render() {
    const parser = new DOMParser();
    const renderedTemplate = template(this);
    const parsedTemplate = parser.parseFromString(renderedTemplate, 'text/html');

    this.container.innerHTML = ''; // Clear the container...
    this.container.appendChild(parsedTemplate.body.firstElementChild);

    this.menuElement = this.container.querySelector('.items-container');
    this.buttonElement = this.container.querySelector('.global-account-menu-button');
  }

  observe() {
    this._clickListener = this.onClick.bind(this);
    this.buttonElement.addEventListener('click', this._clickListener);
  }

  destroy() {
    this.buttonElement.removeEventListener('click', this._clickListener);
    this._clickListener = null;
  }

  open() {
    this.menuElement.removeAttribute('hidden');
    this.buttonElement.classList.add('open');
    if (!this._documentClickListener) {
      this._documentClickListener = this.onDocumentClick.bind(this);
      document.addEventListener('click', this._documentClickListener);
    }
  }

  close() {
    this.menuElement.setAttribute('hidden', true);
    this.buttonElement.classList.remove('open');
    if (this._documentClickListener) {
      document.removeEventListener('click', this._documentClickListener);
      this._documentClickListener = null;
    }
  }

  onClick() {
    if (this.isHidden) {
      this.open();
    } else {
      this.close();
    }
  }

  onDocumentClick(event) {
    if (!this.container.contains(event.target)) {
      this.close();
    }
  }

  get isHidden() {
    return this.menuElement.hasAttribute('hidden');
  }

  get accountName() {
    return this.options.accountName || 'Account';
  }

  get accountUrl() {
    return this.options.accountUrl || DEFAULT_ACCOUNT_LINKS['accountUrl'] || '#';
  }

  get masterAccountUrl() {
    return this.options.masterAccountUrl;
  }

  get logoutUrl() {
    return this.options.logoutUrl || DEFAULT_ACCOUNT_LINKS['logoutUrl'] || '#';
  }

}



// WEBPACK FOOTER //
// ./src/scripts/global-account-menu.js